<template>
  <div class="m-product-pile1">
    <div class="product1">
      <img :src="require('@/assets/mobile/product11.png')"/>
    </div>
    <div class="product2">
      <img :src="require('@/assets/mobile/product12.png')"/>
      <div class="desc">
        <p>国恒充电智慧交流充电桩</p>
        <p>GHJ220032B-3/4G</p>
        <p>坚韧 成熟 品质</p>
      </div>
    </div>
    <div class="product3">
      <img :src="require('@/assets/mobile/product13.png')"/>
      <div class="desc">
        <div>
          <p>ST芯片，168MHz</p>
          <p>主芯片</p>
        </div>
        <div>
          <p>-20℃~50℃</p>
          <p>工作温度</p>
        </div>
        <div>
          <p>32A 七孔</p>
          <p>输出端</p>
        </div>
      </div>
    </div>
    <div class="product4">
      <div class="table">
        <div class="tr">
          <div>外观尺寸</div>
          <div>260mm*260mm*99mm</div>
        </div>
        <div class="tr">
          <div>输入电压</div>
          <div>176V～264V AC</div>
        </div>
        <div class="tr">
          <div>工作频率</div>
          <div>50Hz±5Hz</div>
        </div>
        <div class="tr">
          <div>额定电流</div>
          <div>32A</div>
        </div>
        <div class="tr">
          <div>额定功率</div>
          <div>7kW</div>
        </div>
        <div class="tr">
          <div>充电方式</div>
          <div>二维码</div>
        </div>
        <div class="tr">
          <div>充电接口</div>
          <div>充电枪（GB/T 20234.2-2015）</div>
        </div>
        <div class="tr">
          <div>枪线长度</div>
          <div>3米</div>
        </div>
        <div class="tr">
          <div>显示屏</div>
          <div>无</div>
        </div>
        <div class="tr">
          <div>安装方式</div>
          <div>壁挂/立柱</div>
        </div>
        <div class="tr">
          <div>工作环境</div>
          <div>－20℃～＋50℃  相对湿度5%～95%</div>
        </div>
        <div class="tr">
          <div>储存环境</div>
          <div>－40℃～＋85℃  相对湿度10%～95%</div>
        </div>
        <div class="tr">
          <div>海拔高度</div>
          <div>≤2000米</div>
        </div>
        <div class="tr">
          <div>适用场景</div>
          <div>户内户外</div>
        </div>
        <div class="tr">
          <div>安全保护</div>
          <div>漏电（外置）、过流、欠压、过压、板载防浪涌、接地</div>
        </div>
        <div class="tr">
          <div>IP等级</div>
          <div>IP55</div>
        </div>
        <div class="tr">
          <div>有序充电</div>
          <div>支持</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'productBox'
}
</script>
<style lang="less">
.m-product-pile1{
  background-color: white;
  width: 100%;
  >div{
    position: relative;
  }
  p{
    margin: 0;
  }
  .productg1{
    height: 5.58rem;
  }
  .product2{
    height: 5.37rem;
    .desc{
      width: 100%;
      position: absolute;
      top: .18rem;
      p{
        color: #000;
        &:nth-child(1){
          font-size: 18px;
          line-height: 25px;
        }
        &:nth-child(2){
          font-size: 12px;
          line-height: 16.5px;
          margin-bottom: .16rem;
        }
        &:nth-child(3){
          color: #13E4E8;
          font-size: 12px;
          line-height: 16.5px;
        }
      }
    }
  }
  .product3{
    height: 6.55rem;
    .desc{
      position: absolute;
      width: 100%;
      top: 1.05rem;
      display: flex;
      padding-left: .74rem;
      >div{
        p{
          text-align: center;
          &:first-child{
            font-size: 14px;
            line-height: 20px;
            color: #fff;
          }
          &:last-child{
            font-size: 9px;
            line-height: 12.5px;
            color: #fff;
            opacity: .6;
          }
        }
        &:nth-child(1){
          padding: 0 .27rem 0 0;
        }
        &:nth-child(2){
          padding: 0 .27rem;
          border-left: 1px rgba(255, 255, 255, .5) solid;
          border-right: 1px rgba(255, 255, 255, .5) solid;
        }
        &:nth-child(3){
          padding: 0 0 0 .27rem;
        }
      }
    }
  }
  .product4{
    width: 100%;
    padding: .4rem .35rem .36rem;
    .table{
      border: 1px solid #979797;
      .tr{
        display: flex;
        align-items: center;
        &:not(:last-child) {
          border-bottom: 1px solid #979797;
        }
        >div{
          color: #333;
          font-size: 12px;
          line-height: 16.5px;
          &:nth-child(1){
            width: 1.23rem;
            text-align: center;
            padding: .13rem 0;
          }
          &:nth-child(2){
            border-left: 1px solid #979797;
            width: 5.53rem;
            text-align: left;
            padding: .13rem .27rem;
            word-break:break-all;
          }
        }
      }
    }
  }
  img{
    width: 100%;
    height: 100%;
  }
}
</style>
